import * as z from 'zod/mini'
import { userFields } from '../../schemas/user'

export const setWalkMeBody = z.object({ walkMeDisabled: z.boolean() })
export type SetWalkMeBody = z.infer<typeof setWalkMeBody>

/** A user editing their own profile. Only what is sent changes; the service turns `birthDate` into a `Date`. */
export const editUserBody = z.partial(
  z.object({
    firstName: userFields.firstName,
    lastName: userFields.lastName,
    phone: userFields.phone,
    birthDate: userFields.birthDate,
    description: userFields.description,
  }),
)
export type EditUserBody = z.infer<typeof editUserBody>
